export enum AnalyticsConstants {
    START = 'start',
    SUPPORT = 'support-sibur',
    LOSING = 'losing',
    PLAY_AGAIN = 'play-again',
    VOTE = 'vote'
}